// The database stamps every row (CURRENT_TIMESTAMP) in UTC and the API sends it as "2026-10-07 06:54:21" with no time
// zone. A browser reads such a string as LOCAL time, so a record created at 12:24 PM India time showed as 6:54 AM — 5½
// hours early — on every list, enquiry and notification (found 2026-10-07). This makes `new Date("YYYY-MM-DD HH:MM:SS")`
// (that exact stored format only) mean UTC, so toLocaleString() then shows the viewer's own clock — IST for the team.
// Strings with a "T", a zone, or only a date are left exactly as they were, so dates typed into forms are unaffected.
// Server clock is deliberately left on UTC: scheduled jobs and the stored data are all written for UTC.
const NativeDate = Date;
const STORED = /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}(?:\.\d+)?)$/;
const asUtc = s => (typeof s === 'string' && STORED.test(s.trim()) ? s.trim().replace(' ', 'T') + 'Z' : s);

if (!NativeDate.__utcAware) {
  const Patched = new Proxy(NativeDate, {
    construct(target, args, newTarget) {
      if (args.length === 1) args = [asUtc(args[0])];
      return Reflect.construct(target, args, newTarget);
    },
    get(target, prop, receiver) {
      if (prop === '__utcAware') return true;
      if (prop === 'parse') return s => target.parse(asUtc(s));
      return Reflect.get(target, prop, receiver);
    },
  });
  // eslint-disable-next-line no-global-assign
  window.Date = Patched;
}
